<template>
  <div class="map-container">
    <GmapMap
      ref="gmap"
      :center="mapCenter"
      map-type-id="roadmap"
      :options="{
        styles: dullMapStyle,
        mapTypeControl: false,
        streetViewControl: false,
      }"
      style="width: 100%; height: 100%"
      @ready="onMapReady"
    >
      <GmapMarker
        v-for="(office, index) in localsData"
        :key="index"
        :position="{ lat: office.Lat, lng: office.Lng }"
        :title="office.name"
        @click="selectOffice(office)"
      />
      <GmapInfoWindow
        v-if="selectedOffice"
        :position="{ lat: selectedOffice.Lat, lng: selectedOffice.Lng }"
        :opened="true"
        @closeclick="selectedOffice = null"
      >
        <div>
          <v-row no-gutters align="center" justify="center">
            <img
              v-if="selectedOffice.Logo"
              :src="selectedOffice.Logo"
              alt="Logo"
              style="width: auto; height: 50px; margin-bottom: 4px"
            />
            <h4 style="margin: 0 10px">{{ selectedOffice.Name }}</h4>
          </v-row>
          <p style="margin: 4px 0">{{ selectedOffice.Address }}</p>
          <p style="margin: 4px 0">
            Members:
            <strong>{{ selectedOffice.MemberCount.toLocaleString() }}</strong>
          </p>
          <p style="margin: 4px 0">
            Local Time:
            {{ getLocalTime(selectedOffice.TimeZone) }}
          </p>
          <a :href="selectedOffice.Website" target="_blank">Website</a>
        </div>
      </GmapInfoWindow>
    </GmapMap>
    <error-handler :error="error"></error-handler>

    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{ successMessage }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler.vue";

export default {
  components: {
    ErrorHandler,
  },
  data() {
    return {
      mapCenter: { lat: 54.526, lng: -105.2551 },
      selectedOffice: null,
      loading: false,
      loadingTypes: false,
      error: undefined,
      snackbar: false,
      successMessage: "",
      keywordToSearch: null,
      address: null,
      theLocation: "",
      theKeyword: "",
      cityState: "",
      curPlace: null,
      geocoder: null,
      myCityData: null,
      mapRef: null,
      googleGeometryMultiPoly: [],
      numGeometries: 0,
      dullMapStyle: [
        {
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }],
        },
        {
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [{ color: "#f5f5f5" }],
        },
        {
          featureType: "administrative.land_parcel",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "poi",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "road",
          stylers: [{ visibility: "simplified" }],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [{ color: "#757575" }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#dadada" }],
        },
        {
          featureType: "transit",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#c9c9c9" }],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9e9e9e" }],
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", ["userProfile", "settings", "localsData"]),
    ...mapGetters("auth", ["user"]),
  },
  mounted() {
    this.$refs.gmap.$mapPromise.then((map) => {
      this.fitBoundsToMarkers(map);
    });
  },
  methods: {
    onMapReady(map) {
      this.mapRef = map;
      window.google.maps.event.addListenerOnce(map, "idle", () => {
        this.fitBoundsToMarkers(map);
      });
    },
    fitBoundsToMarkers(map) {
      if (!map || !this.localsData.length) return;
      const bounds = new window.google.maps.LatLngBounds();
      this.localsData.forEach((office) => {
        bounds.extend(new window.google.maps.LatLng(office.Lat, office.Lng));
      });
      map.fitBounds(bounds);
    },
    selectOffice(office) {
      this.selectedOffice = office;
    },
    getLocalTime(timeZone) {
      if (!timeZone) return "N/A";
      try {
        const dateStr = new Intl.DateTimeFormat("en-US", {
          timeZone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }).format(new Date());

        return dateStr;
      } catch (e) {
        return "Invalid TimeZone";
      }
    },
  },
};
</script>
<style scoped>
.input-label {
  font-size: 14px;
  font-weight: 600;
}
button.v-btn--fab {
  background-color: #fff !important;
}
.note-text {
  font-size: 15px;
  line-height: 1.1;
}
.map-container {
  width: 100%;
  height: 360px;
}
</style>
